export const generateRandomColor = () => {
  // const h = Math.floor(Math.random() * 360),
  //   s = Math.floor(Math.random() * 100) + '%',
  //   l = Math.floor(Math.random() * 60) + '%'; // max value of l is 100, but I set to 60 cause I want to generate dark colors
  // // (use for background with white/light font color)
  // return `hsl(${h},${s},${l})`;
  const green = Math.floor(Math.random() * 200);
  const blue = Math.floor(Math.random() * 200);
  return 'rgb(' + 0 + ', ' + green + ', ' + blue + ')';
};

export const emojis = [
  {
    id: 1,
    value: '👍',
    title: 'LIKE',
    slug: 'Like',
  },
  {
    id: 2,
    value: '👎',
    title: 'DISLIKE',
    slug: 'Dislike',
  },
  {
    id: 3,
    value: '😍',
    title: 'HEART_EYES',
    slug: 'Love',
  },
];

export const getReactColor = (type: string) => {
  let color = '';

  switch (type) {
    case 'DISLIKE':
      color = 'text-danger';
      break;
    case 'HEART_EYES':
      color = 'text-danger';
      break;
    default:
      color = 'text-primary';
  }
  return color;
};
